import {connect} from 'react-redux';
import {IntlProvider} from 'react-intl';
import 'intl';
import 'intl/locale-data/jsonp/en.js';

const mapStateToProps = () => {
    return {locale: 'en'};
};

export default connect(mapStateToProps)(IntlProvider);



// WEBPACK FOOTER //
// ./src/common/IntlSetup.js